// ===================================
// SESSIONS API SERVICE
// src/services/sessionsApi.js
// ===================================

import api from './api';

/**
 * Get all sessions for current user
 */
export const getSessions = async (params = {}) => {
  const response = await api.get('/sessions', { params });
  return response.data.sessions || response.data || [];
};

/**
 * Get single session by ID
 */
export const getSession = async (sessionId) => {
  const response = await api.get(`/sessions/${sessionId}`);
  // Handle both response formats
  return response.data.session || response.data;
};

/**
 * Get session statistics
 */
export const getSessionStats = async () => {
  const response = await api.get('/sessions/stats');
  return response.data;
};

/**
 * Validate access code
 */
export const validateAccessCode = async (code) => {
  const response = await api.post('/sessions/validate-code', { code });
  return response.data;
};

/**
 * Start a session
 */
export const startSession = async (sessionId) => {
  const response = await api.post(`/sessions/${sessionId}/start`);
  return response.data;
};

/**
 * End a session
 */
export const endSession = async (sessionId, data = {}) => {
  const response = await api.post(`/sessions/${sessionId}/end`, data);
  return response.data;
};

/**
 * Update session transcript
 */
export const updateTranscript = async (sessionId, transcript) => {
  const response = await api.put(`/sessions/${sessionId}/transcript`, { transcript });
  return response.data;
};

/**
 * Update session score
 */
export const updateScore = async (sessionId, scoreData) => {
  const response = await api.put(`/sessions/${sessionId}/score`, scoreData);
  return response.data;
};